import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import GNS3Register from 'src/custom/gns3/Register' // Custom Registration Page
import { useOrganization } from 'src/graphql/hooks'
import ForgotPassword from './apps/ForgotPassword'
import Login from './apps/Login'
import Logout from './apps/Logout'
import Register from './apps/Register'
import ResetPassword from './apps/ResetPassword'

const Account = ({ match }) => {
   const { organization } = useOrganization()

   return (
      <Switch>
         <Route path={`${match.url}/login`} component={Login} />
         <Route path={`${match.url}/logout`} component={Logout} />
         <Route path={`${match.url}/forgot-password`} component={ForgotPassword} />
         <Route
            path={`${match.url}/register`}
            component={organization.slug === 'gns3' ? GNS3Register : Register}
         />
         <Route path={`${match.url}/reset-password`} component={ResetPassword} />
      </Switch>
   )
}

Account.propTypes = {
   match: PropTypes.object.isRequired
}

export default Account
